<template>
  <div class="epicerie">
    <h2 class="titlePage">
      <strong>_</strong>
      La Camionnette de Nanou
      <strong>_</strong>
    </h2>
    <p class="intro">
      En plus de toutes les prestations que nous pouvons vous proposer, un service supplémentaire nous tenait à cœur :
      <br />une épicerie itinérante et traditionnelle.
    </p>
    <br />

    <div class="hebItem">
      <transition name="fade" appear>
        <img
          src="@/assets/images/epicerie/camionnette.jpg"
          class="bigImg"
          alt="la camionnette de Nanou "
        />
      </transition>

      <div class="absoInfos wow leftToRight">
        <!-- <h2 class="titlePage" style="margin-right: 10%">
          <strong>_</strong>
          La Camionnette
        </h2>
        <h2 class="titlePage">
          de Nanou
          <strong>_</strong>
        </h2>-->
        <h4>Épicerie itinérante</h4>
        <h4 class="secondH3">et traditionnelle</h4>

        <a
          v-for="wu in pdfFromServer.slice(0, 2)"
          :key="wu.idC"
          :href="getPdfUrl(wu.idC, wu.documentC )"
          target="_blank"
          rel="noopener noreferrer"
          :title=" wu.titleC "
          class="greenBtn orangeIndeed"
        >{{ wu.titleC }}</a>
        <br />
        <br />
        <br />
        <br />
        <a
          href="https://www.facebook.com/La-Camionnette-de-Nanou-108517837614888"
          target="_blank"
          rel="noopener"
          class="fbLink"
        >
          <i class="fab fa-facebook fa-3x"></i>
        </a>
      </div>
    </div>

    <!-- <div class="headEpi">
      <transition name="fade" appear>
        <img
          src="@/assets/images/epicerie/camionnette.jpg"
          class="bigImg"
          alt="la camionnette de Nanou "
        />
      </transition>
      <transition name="textAppear" appear>
        <div class="absTitle">
          <h2>La Camionnette de Nanou</h2>
          <br />
          <h3>Épicerie itinérante</h3>
          <h3 class="secondH3">et traditionnelle</h3>
        </div>
      </transition>
    </div>-->

    <section class="epi_content">
      <div class="imgBox">
        <img
          src="@/assets/images/epicerie/fraise.jpg"
          alt="Epicerie - la camionnette de Nanou Gite en lebé"
          class="imgOne"
        />
        <img
          src="@/assets/images/epicerie/lentille.jpg"
          alt="Epicerie - la camionnette de Nanou Gite en lebé"
          class="imgThree"
        />
        <img
          src="@/assets/images/epicerie/radis.jpg"
          alt="Epicerie - la camionnette de Nanou Gite en lebé"
          class="imgFour"
        />
        <img
          src="@/assets/images/epicerie/tomates.jpg"
          alt="Epicerie - la camionnette de Nanou Gite en lebé"
          class="imgTwo"
        />
        <img
          src="@/assets/images/epicerie/pain.jpg"
          alt="Epicerie - la camionnette de Nanou Gite en lebé"
          class="imgFive"
        />
      </div>

      <article>
        <p>
          <b>Ce projet d’épicerie itinérante prend tout son sens aujourd’hui !</b>
        </p>

        <p>
          Plus que jamais, nous avons besoin de proximité, d’écoute, de qualité, de conseils …
          de favoriser les circuits courts, locaux, les produits de saison. Nous avons de la chance, le Gers offre cette opportunité.
        </p>
        <p>
          <span
            class="orangeText"
          >Nous sélectionnons pour vous les meilleurs produits de notre proche territoire : du bon, du bio, du local.</span>
          Nous serons au service de la population rurale et isolée,
          de ceux qui ont pris goût au télétravail, des actifs sur leur lieu de travail, et une petite halte au cœur de magnifiques villages dépourvus de commerces est prévue.
        </p>
        <p
          class="orangeText"
        >Bien entendu, le zéro déchet est favorisé, venez avec vos cabas, paniers, sacs …</p>
        <p>Un service sur commande est un service efficace, pensez-y !</p>
        <p>
          Nous retrouvons le lien social et le sourire de nos anciens, les bons produits locaux et l’envie de bien consommer !
          <br />
          <br />La Camionnette d’autrefois …. si moderne à la fois !
          <br />Je reste joignable par téléphone, mail ou via
          <a
            title="page facebook épicerie"
            class="orangeText"
            href="https://www.facebook.com/G%C3%AEte-dEn-L%C3%A9b%C3%A9-456315311052792/"
            target="_blank"
            rel="noopener"
          >la Page Facebook</a>.
        </p>

        <p>À TRÉS BIENTÔT</p>

        <div class="cartevisiteBox">
          <img
            src="@/assets/images/epicerie/CARTE-VISITE-RECTO.jpg"
            alt="Epicerie - la camionnette de Nanou Gite en lebé"
          />
          <img
            src="@/assets/images/epicerie/CARTE-VISITE-VERSO.jpg"
            alt="Epicerie - la camionnette de Nanou Gite en lebé"
          />
        </div>
        <!-- <section class="pdfSection" v-if="pdfFromServer">
          <article v-for="wu in pdfFromServer.slice(0, 2)" :key="wu.idC">
            <a
              :href="getPdfUrl(wu.idC, wu.documentC )"
              target="_blank"
              rel="noopener noreferrer"
              :title=" wu.titleC "
            >
              <i class="fas fa-file-pdf"></i>
            </a>
            <h4>
              <a
                :href="getPdfUrl(wu.idC, wu.documentC )"
                target="_blank"
                rel="noopener noreferrer"
                :title=" wu.titleC "
              >{{ wu.titleC }}</a>
            </h4>
            <p v-html="wu.describeC"></p>
          </article>
        </section>-->
      </article>
    </section>
  </div>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import WOW from "@/assets/wow.min.js";

export default {
  name: "Epicerie",

  components: {
    Slideshow,
  },

  data() {
    return {
      pdfFromServer: null,
    };
  },

  components: {},

  created() {
    new WOW(
      { mobile: false } // default
    ).init();

    this.getPdf();
  },

  methods: {
    getPdf() {
      if (this.pdfFromServer == null) {
        fetch("https://ws-gbbu02.graphibox.eu/WebService.asmx/GetCobWeb", {
          method: "POST",
          headers: { "Content-Type": "application/json;  charset=utf-8" },
          body: JSON.stringify({
            pKey: "bji3PXMCkqnoOK7sZfcEqn6s3m6kwEkJ",
            pId: 0,
            pIdCat: 6,
            pNbItems: 0,
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then((res) => {
            this.pdfFromServer = JSON.parse(res.d);
          });
      }
    },
    getPdfUrl(id, name) {
      const url =
        "https://cdn-gbbu02.graphibox.eu/pub/" +
        this.$store.state.globalData.siteId +
        "/medias/shared-files/";

      return url + id + "/" + name;
    },
  },
};
</script>
<style>
.epicerie {
  margin-top: 2rem;
}
.epicerie .imgBox {
  width: 40%;
  margin: 0 5%;
  position: relative;
  text-align: center;
}
.epicerie .imgBox img {
  border: 2px white solid;
  border-bottom: 0;
  border-top: 0;
  width: 100%;
  height: 23vh;
  object-fit: cover;
}
.epicerie article {
  margin-right: 8%;
  font-size: 1.2rem;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pdfSection {
  display: flex;
  padding: 1rem 0;
}
.orangeText {
  color: rgb(238, 120, 84);
}
.pdfSection article {
  border-radius: 8px;
  text-align: center;
}
.pdfSection h4 {
  margin: 0;
  margin-top: 10px;
  font-size: 2rem;
  font-family: "Dancing";
}
.pdfSection p {
  margin: 0;
  font-size: 1.2rem;
}
.pdfSection i {
  margin-top: 8px;
  font-size: 3em;
  color: rgb(238, 120, 84);
}

.fbLink {
  color: rgb(238, 120, 84);
  margin-top: 1rem;
  margin-left: auto;
}
.bigImg {
  max-width: 60%;
}
.absTitle {
  position: absolute;
  top: 50%;
  right: 2%;
  transform: translateY(-50%);
}

.headEpi {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.epi_content {
  display: flex;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.headEpi h2 {
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 8px;
  padding-left: 1vw;
  font-size: 4.4vw;
  font-weight: normal;
  color: rgb(238, 120, 84);
  word-spacing: 2px;
  background: white;
}
.epicerie .titlePage {
  color: rgb(238, 120, 84);
  padding-left: 1vw;
  margin-left: auto;
  margin-bottom: 2rem;
}
.epicerie .intro {
  font-size: 1.2rem;
  text-align: center;
}
.absoInfos h4 {
  margin: 0;
  margin-bottom: 1rem;
  margin-left: auto;
  font-size: 3rem;
  font-weight: normal;
  color: rgb(116, 93, 85);
  word-spacing: 2px;
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
}
.absoInfos .secondH3 {
  margin-right: 0;
}

.absoInfos .greenBtn.orangeIndeed {
  margin-left: auto;
  color: rgb(238, 120, 84);
  border: 2px rgb(238, 120, 84) solid;
}
.absoInfos .greenBtn.orangeIndeed:hover {
  color: white;
  background: rgb(238, 120, 84);
}
.cartevisiteBox {
  margin: 3rem 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.cartevisiteBox img {
  max-width: 45%;
}

@media all and (max-width: 1000px) {
  .epicerie {
    flex-direction: column;
  }
  .epicerie .imgBox {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    margin: 0;
  }

  .epicerie .imgBox img {
    max-width: 40%;
  }
  .epicerie article {
    width: 90%;
    margin: 5%;
  }
  .epicerie .imgBox img {
    max-width: 50%;
  }
}
@media all and (max-width: 950px) {
  .epicerie .imgBox {
    display: none;
  }
}
@media all and (max-width: 700px) {
  .bigImg {
    max-width: 100%;
  }
  .absTitle {
    position: absolute;
    right: 0;
    bottom: 0;
    top: unset;
    transform: none;
  }
  .absTitle > * {
    padding-right: 2vw;
  }
  .epi_content {
    margin-top: 0;
  }
}

@media all and (max-width: 400px) {
  .pdfSection {
    flex-direction: column;
  }
}

.textAppear-enter-active,
.textAppear-leave-active {
  transition: all 2.5s;
}
.textAppear-enter {
  opacity: 0;
  transform: translate(50%, -50%);
}
</style>


